/*
 * https://www.drupal.org/docs/8/api/javascript-api/javascript-api-overview
 */

(function () {
  "use strict";
  //   Drupal.behaviors.common = {
  //     attach: function (context, settings) {
  //       // this hack to override scroll at very top page after ajax submit
  //       setTimeout(() => {
  //         $('html, body').animate({ scrollTop: 0 }, 'slow');
  //       }, 0);
  //   }
  // };

  /* cloniamo la CTA nella hero per farla vedere in una navbar sticky dedicata */
  let heroCta = $(".it-hero-text-wrapper-sticky .it-hero-cta");
  let heroCtaCloned = $("it-hero-cta-cloned");
  let sme = 1;
  if (heroCta.length && heroCtaCloned.length == 0) {
    if (sme === 1) {
      heroCta
        .clone()
        .appendTo(".it-header-wrapper .it-nav-wrapper")
        .addClass("it-hero-cta-cloned ");
      sme = 0;
    }
  }

  /*
   *
   *
   * navbar management
   *
   *
   * */

  var headerSlimHeight = $(".it-header-slim-wrapper").height();
  let handleCta = (force) => {
    var hero = $(".it-hero-wrapper");
    var heroCtaCloned = $(".it-hero-cta-cloned");
    if (hero.length) {
      if (window.pageYOffset > hero.offset().top + hero.height() - 80) {
        if (heroCtaCloned.length) {
          heroCtaCloned.fadeIn().addClass("show");
        }
      } else {
        if (heroCtaCloned.length) {
          heroCtaCloned.fadeOut().removeClass("show");
        }
      }
      if (force) {
        heroCtaCloned.fadeIn().addClass("show");
      }
    }
  };
  let collapseMenu = (force) => {
    var scroll = $(window).scrollTop();

    var headerSlim = $(".it-header-slim-wrapper");
    var headerWrapper = $(".it-header-wrapper");
    var mainNav = $(".it-header-navbar-wrapper");
    var scrollNav = $(".it-navscroll-spy-wrapper.it-navscroll-tofix");
    /*
     * usiamo la classe affix-top-tofix per distanziare correttamente l'affix-top in base la menu_sticky collasato
     */
    var affixTopToFix = $(".affix-top.affix-top-tofix");

    var heroCtaCloned = $(".it-hero-cta-cloned");
    if (force || scroll > headerSlimHeight) {
      headerWrapper.addClass("menu_sticky");
      mainNav.slideUp("fast");
      headerSlim.slideUp("fast");
      var topNav;
      if ($(window).width() > 991) {
        if (scrollNav.length) {
          if (heroCtaCloned.length) {
            topNav = headerWrapper.height() * 2 + heroCtaCloned.height() - 10;
          } else {
            topNav = headerWrapper.height() * 2 - 10;
          }
          scrollNav.css("top", topNav);
        }
        if (affixTopToFix.length) {
          topNav = headerWrapper.height() + 10;
          affixTopToFix.css("top", topNav);
        }
      }
    } else {
      headerWrapper.removeClass("menu_sticky");
      mainNav.slideDown("fast");
      headerSlim.slideDown("fast");
    }
  };
  let handleSpy = () => {
    var scrollNav = $(".it-navscroll-spy-wrapper.it-navscroll-tofix");
    if (scrollNav.length) {
      $(".main-content-fields > div").removeClass("active");

      $("#navSpyScroll .nav-item .nav-link.nav-link-main").each(function () {
        if ($(this).hasClass("active")) {
          var target = $(this).data("target");
          $(target).addClass("active");
          $(".main-content-fields > .nav-link")
            .not(target)
            .removeClass("active");
        }
      });
    }
  };
  let handleScroll = () => {
    collapseMenu(false);
    // handleSpy();
    setTimeout(() => {
      /* gestiamo l'highlight dei div in base ai nav item*/
      handleSpy();
    }, 100);
  };
  var manageScroll = true;
  let attachScroll = () => {
    $(window).scroll(function () {
      if (manageScroll) {
        handleScroll();
      }
      handleCta(false);
    });
  };

  attachScroll();

  /*
   *
   *
   * anchor scroll di pagina
   *
   *
   * * */
  let checkHasSticky = () => {
    var navSpyScroll = $("#navSpyScroll");
    var affix = $('div[class^="affix-"]');
    var body = $("body");
    if (navSpyScroll.length || affix.length) {
      if (!body.hasClass("has-sticky-element")) {
        body.addClass("has-sticky-element");
      }
    }
  };
  checkHasSticky();

  $("#navSpyScroll .nav-item").on("click keydown", function (e) {
    /* disabillitiamo monentaneamente la gestione hanlescroll altrimenti in scroll non permette di calcolare correttamente l'header*/
    manageScroll = false;
    /* ci prendiamo il riferimento al div da scrollare*/
    let divId = $(this).children(".nav-link-dtop").attr("href");
    /* forziamo il collapse del menu header*/
    collapseMenu(true);

    setTimeout(() => {
      let heroCtaCloned = $(".it-hero-cta-cloned");

      let navbar = $(".it-header-wrapper").height();

      let heroCtaClonedHeight = 0;
      if (heroCtaCloned.length) {
        /* forziamo lo show della cta*/
        handleCta(true);
        heroCtaClonedHeight = heroCtaCloned.height();
      }

      var scrollValue =
        $(divId).offset().top - navbar - 1 - heroCtaClonedHeight;
      $("html, body").animate(
        {
          scrollTop: scrollValue,
        },
        500
      );
      /* gestiamo la sequenza degli eventi*/

      setTimeout(() => {
        /* lo chiamiamo dopo l'animate e solo una volta */
        handleScroll();
      }, 300);
      setTimeout(() => {
        /* riabilitiamo il listener per l'handlescroll */
        manageScroll = true;
      }, 1000);
    }, 300);
  });

  $(window).on("resize", function () {
    if ($(window).width() < 991) {
      $("#navSpyScroll")
        .removeClass("it-navscroll-spy-wrapper")
        .addClass("it-navscroll-wrapper");
    }
  });
  if ($(window).width() < 991) {
    $("#navSpyScroll")
      .removeClass("it-navscroll-spy-wrapper")
      .addClass("it-navscroll-wrapper");
  }

  //var headerHeight = $(".it-header-wrapper").height();
  // $('main').css('padding-top', headerHeight);
  var menuOffcanvas = document.getElementById("menu-offcanvas");
  var btnOpenOffcanvas = document.getElementById("openOffCanvas");
  var btnCloseOffcanvas = document.getElementById("closeOffcanvas");
  var mainNav = $(".it-header-navbar-wrapper");
  var mainbody = document.body;
  var offcanvasOverlay = document.getElementsByClassName("offcanvas-overlay");

  let handleMainPaddingtop = (selector) => {
    var size = $(selector).height();
    var headerTop = $(".it-header-slim-wrapper").height();
    var headerMain = $(".it-nav-wrapper").height();
    var realSize = headerTop + headerMain;
    $("main").css("padding-top", realSize);
  };
  let setNavigationOffcanvasMenu = (active) => {
    if (active == true) {
      $("#menu-offcanvas a").attr("tabindex", "0");
    } else {
      $("#menu-offcanvas a").attr("tabindex", "-1");
    }
  };
  setNavigationOffcanvasMenu(false);
  let handleMenu = () => {
    if ($(window).width() > 1024) {
      // main menu
      if (btnOpenOffcanvas) {
        btnOpenOffcanvas.onclick = function () {
          classie.toggle(this, "active");
          mainNav.slideToggle();
        };
      }
    } else {
      // menu mobile
      if (btnOpenOffcanvas && btnCloseOffcanvas && offcanvasOverlay) {
        btnOpenOffcanvas.onclick = function () {
          //classie.toggle( this, 'active' );
          classie.toggle(menuOffcanvas, "cbp-spmenu-open");
          classie.toggle(mainbody, "offCanvas-open");
          setNavigationOffcanvasMenu(true);
        };
        btnCloseOffcanvas.onclick = function () {
          classie.toggle(this, "active");
          classie.toggle(menuOffcanvas, "cbp-spmenu-open");
          classie.toggle(mainbody, "offCanvas-open");
          setNavigationOffcanvasMenu(false);
        };
        offcanvasOverlay.onclick = function () {
          classie.toggle(menuOffcanvas, "cbp-spmenu-open");
          classie.toggle(mainbody, "offCanvas-open");
          setNavigationOffcanvasMenu(false);
        };
      }
    }
  };
  handleMainPaddingtop(".it-header-wrapper");
  handleMenu();
  $(window).resize(function () {
    handleMenu();
    // handleMainPaddingtop('.it-header-wrapper');
  });

  //

  /*
   *
   * carousel
   * */
  // $('.owl-carousel').owlCarousel();
  $("#prodCarousel").carousel({
    interval: 10000,
  });

  // gestiamo lo scroll degli input in focus ed in mobile
  if ($(window).width() < 1025) {
    $("input,select,textarea").focus(function (e) {
      setTimeout(() => {
        var hh = $(".it-header-wrapper").height();
        var ot = $(this).offset().top;
        var scrollsize = ot - hh - 20;
        $("html, body").animate(
          {
            scrollTop: scrollsize + "px",
          },
          "fast"
        );
      }, 100);
    });
  }
})(jQuery, Drupal);

/*!
 * classie - class helper functions
 * from bonzo https://github.com/ded/bonzo
 *
 * classie.has( elem, 'my-class' ) -> true/false
 * classie.add( elem, 'my-new-class' )
 * classie.remove( elem, 'my-unwanted-class' )
 * classie.toggle( elem, 'my-class' )
 * classie.convertHex(hex,opacity)
 */

/*jshint browser: true, strict: true, undef: true */

(function (window) {
  "use strict";

  // class helper functions from bonzo https://github.com/ded/bonzo

  function classReg(className) {
    return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
  }

  // classList support for class management
  // altho to be fair, the api sucks because it won't accept multiple classes at once
  var hasClass, addClass, removeClass;

  if ("classList" in document.documentElement) {
    hasClass = function (elem, c) {
      return elem.classList.contains(c);
    };
    addClass = function (elem, c) {
      elem.classList.add(c);
    };
    removeClass = function (elem, c) {
      elem.classList.remove(c);
    };
  } else {
    hasClass = function (elem, c) {
      return classReg(c).test(elem.className);
    };
    addClass = function (elem, c) {
      if (!hasClass(elem, c)) {
        elem.className = elem.className + " " + c;
      }
    };
    removeClass = function (elem, c) {
      elem.className = elem.className.replace(classReg(c), " ");
    };
  }

  function toggleClass(elem, c) {
    var fn = hasClass(elem, c) ? removeClass : addClass;
    fn(elem, c);
  }

  function convertHex(hex, opacity) {
    hex = hex.replace("#", "");
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    let result = "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
    return result;
  }

  window.classie = {
    // full names
    hasClass: hasClass,
    addClass: addClass,
    removeClass: removeClass,
    toggleClass: toggleClass,
    convertHex: convertHex,

    // short names
    has: hasClass,
    add: addClass,
    remove: removeClass,
    toggle: toggleClass,
  };
})(window);

$(document).ready(function () {
  /*#################################################################
  /*#################################################################
  /*Gestione ente e tipologia ente in /strutture-periferiche
  /*#################################################################
  /*#################################################################
 
  /*
  *retrieve taxonomy from service
  * */

  let GetDataTaxonomy = (vocabulary, ids, selector) => {
    // var selector = "#edit-field-"+type+"-target-id";
    // var idsc=null;
    jQuery.ajax({
      type: "GET",
      url:
        drupalSettings.path.baseUrl +
        "api/rest/taxonomy/" +
        vocabulary +
        "/" +
        ids,
      //url:  Drupal.url()+"/api/rest/taxonomy/"+vocabulary+"/"+ids,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      success: function (data) {
        jQuery(selector).html("");
        jQuery.each(data, function () {
          var options =
            "<option " +
            "value='" +
            this.tid +
            "' data-token='" +
            this.name +
            "'>" +
            this.name +
            "";
          jQuery(selector).append(options);
        });
        jQuery(".selectpicker").selectpicker("refresh");
      },
      failure: function () {
        alert("Failed!");
      },
    });
  };

  let handleSelectTaxonomy = (
    source,
    vacabulary,
    target,
    hiderelated = null
  ) => {
    /* hide  term related on load */
    if (hiderelated) {
      jQuery(target).on("loaded.bs.select", function (e) {
        let sourceVal = jQuery(source).val();
        sourceVal = sourceVal.toLowerCase();

        let targetVal = jQuery(target).val();
        targetVal = targetVal.toLowerCase();
        GetDataTaxonomy(vacabulary, sourceVal, target);
        if (targetVal != "all") {
          jQuery(target).val(targetVal);
        }

        if (targetVal == "all" && sourceVal == "all" && hiderelated) {
          /*nascosto perchè non definito*/
          hiderelated.hide();
        }
      });
    }
    jQuery(source).on("changed.bs.select", function (e) {
      let selected = jQuery(this).val();
      selected = selected.toLowerCase();
      if (selected == "all" && hiderelated) {
        hiderelated.slideUp();
      } else {
        hiderelated.slideDown();
      }

      GetDataTaxonomy(vacabulary, selected, target);
    });
  };

  let source = jQuery('select[name="field_ente_target_id"]');
  let target = jQuery('select[name="field_tipologia_ente_target_id"]');
  let termrelated = jQuery(".form-item-field-tipologia-ente-target-id");

  handleSelectTaxonomy(source, "tipologia_ente", target, termrelated);

  /*#################################################################
  /*#################################################################
  /*Gestione registrazione utente: comune provincia regione
  /*#################################################################
  /*#################################################################*/
  let form_registration = $("#user-register-form");
  let comune;
  let comune_select = $("#edit-field-comune"); //id in caso di menu a tendina per il comune
  let comune_input = $("#edit-field-comune-0-target-id"); //id in caso di autocomplete per il comune

  let divRP; //init: il div che conterrà la stringa con regione/provincia

  if (comune_select.length) {
    comune = comune_select;
    divRP = $("#edit-field-comune--description");
  } else if (comune_input.length) {
    comune = comune_input;
    divRP = $("#edit-field-comune-0-target-id--description");
  }
  if (form_registration) {
    $("#edit-field-regione-wrapper").css("display", "none");
    $("#edit-field-provincia-wrapper").css("display", "none");
  }

  let setAppartenenzaComune = (
    comuneId,
    comune_select,
    comune_input,
    divRP
  ) => {
    let provincia = $("#edit-field-provincia");
    let regione = $("#edit-field-regione");
    let baseUrl = drupalSettings.path.baseUrl;
    let endPointComune;
    // in caso di comune con menu a tendina
    if (comune_select.length) {
      endPointComune = baseUrl + "comuni/" + comuneId;
    }

    //in caso di comune con autocomplete, interrogo l'api con il nome del comune scelto
    if (comune_input.length) {
      let strComune = comuneId.slice(0, comuneId.indexOf("("));
      endPointComune = baseUrl + "comuni?comune=" + strComune;
    }

    let messaggio =
        "<span style='color:red'>Attenzione! Selezionare un comune dalla lista</span>",
      strProvincia,
      strRegione;

    $.getJSON(endPointComune)
      .then(function (dataCom) {
        let prov = dataCom.cprvcod;
        return $.getJSON(baseUrl + "province?prov=" + prov); //call 2: province
      })
      .then(function (dataProv) {
        strProvincia = dataProv.cprvden;
        provincia.selectpicker("val", dataProv.id);
        return $.getJSON(baseUrl + "regioni?cregcod=" + dataProv.cregcod); //call 3
      })
      .then(function (dataReg) {
        strRegione = dataReg.cregden;
        regione.selectpicker("val", dataReg.id);
      })
      .then(function () {
        if (strRegione || strProvincia)
          messaggio = strRegione + " / " + strProvincia;

        divRP.html(`<strong>${messaggio}</strong>`);
        // provincia.prop('disabled', true);
        // regione.prop('disabled', true);
      })
      .fail(console.log.bind(console));
  };

  //regione.prop( "disabled", true );
  if (typeof comune !== "undefined") {
    let comuneId = comune.val();
    if (comuneId)
      setAppartenenzaComune(comuneId, comune_select, comune_input, divRP);

    comune.change(function () {
      comuneId = $(this).val();
      setAppartenenzaComune(comuneId, comune_select, comune_input, divRP);
    });
  }

  /*#################################################################
  /*#################################################################
  /*Gestione in mobile dello scrol di pagina dei campi bootstrap select
  /*#################################################################
  /*#################################################################*/

  /* extend accessibility to inner dropdown in bootstrap-select*/
  $(".selectpicker").on("loaded.bs.select", function () {
    var that = jQuery(this);
    var dropdown = that.siblings(".dropdown-menu");
    var thisId = that.attr("id");
    var label = jQuery('label[for="' + thisId + '"]').text();
    if (!label || label == "") {
      label = "una opzione";
    }
    jQuery(dropdown)
      .find(".inner")
      .attr("aria-label", "Seleziona " + label);
  });
  if ($(window).width() < 1025) {
    $.fn.selectpicker.Constructor.DEFAULTS.dropupAuto = false;
    $(".selectpicker").on("show.bs.select", function () {
      var hh = 0,
        ot;
      if (window.matchMedia("(orientation: portrait)").matches) {
        //portrait
        hh = $(".it-header-wrapper").height();
      }
      ot = $(this).offset().top;
      var scrollsize = ot - hh - 20;
      $("html, body").animate(
        {
          scrollTop: scrollsize + "px",
        },
        "fast"
      );
    });
  }
});
